<template>
  <el-form-item :label="label" :label-width="labelWidth">
    <el-select
      v-model="selectedId"
      placeholder="请选择"
      style="width: 100%;"
      filterable
      clearable
      :disabled="disabled"
    >
      <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: "RoleSelector",
  props: {
    label: String,
    labelWidth: String,
    roleId:Number
  },
  data() {
    return {
      selectedId: null,
      roles: [],
      disabled: false
    };
  },
  methods: {
    query() {
      var self = this;
      this.$axios.get("system/role/query").then(function(response) {
        if (response.data.errorCode == "00000") {
          self.roles = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    }
  },
  created: function() {
    console.log("role selector created");
    this.selectedId = this.roleId;
    this.query();
  }
};
</script>